<template>
    <div v-show="loaded">
        <h1>Мой состав</h1>
        <p class="hint">
            В каждой пятёрке должно быть 2 защитника, один центрфорвард, один левый и один правый нападающий.
            <br/>В одной из трех пятерок могут играть 2 защитника и 3 нападающих любого амплуа.
            <br/>Последовательность пятерок определяется менеджером.
        </p>
        <v-layout class="hidden-sm-and-up"
                  column
                  align-center
                  justify-space-beetwen>
            <v-select
                    class="link_sm selector"
                    v-model="selectedGoalkeepers[0]"
                    :items="availableGoalkeepers(selectedGoalkeepers[0])"
                    label="Вратарь (основной)"
                    item-text="desc"
                    no-data-text="У вас больше игроков на этой позиции"
                    return-object
                    clearable
                    hide-selected>

            </v-select>
            <v-select
                    class="link_sm selector"
                    v-model="selectedGoalkeepers[1]"
                    :items="availableGoalkeepers(selectedGoalkeepers[1])"
                    label="Вратарь (запасной)"
                    item-text="desc"
                    no-data-text="У вас больше игроков на этой позиции"
                    return-object
                    clearable
                    hide-selected>

            </v-select>
        </v-layout>
        <v-layout class="hidden-md-and-down"
                  row
                  align-center
                  justify-space-beetwen>
            <v-select
                    class="link selector"
                    v-model="selectedGoalkeepers[0]"
                    :items="availableGoalkeepers(selectedGoalkeepers[0])"
                    label="Вратарь (основной)"
                    item-text="desc"
                    no-data-text="У вас больше игроков на этой позиции"
                    return-object
                    clearable
                    hide-selected>

            </v-select>
            <v-select
                    class="link selector"
                    v-model="selectedGoalkeepers[1]"
                    :items="availableGoalkeepers(selectedGoalkeepers[1])"
                    label="Вратарь (запасной)"
                    item-text="desc"
                    no-data-text="У вас больше игроков на этой позиции"
                    return-object
                    clearable
                    hide-selected>

            </v-select>
        </v-layout>

        <v-layout column class="hidden-md-and-up" justify-space-beetwen>
            <v-layout class="link_sm" column v-for="link in 3" :key="link">
                <h3 class="px-0">Пятерка {{link}}</h3>
                <v-layout column>
                    <h5>Защитники</h5>
                    <v-select
                            class="selector"
                            v-model="selectedDefenders[(link-1)*2]"
                            label="Защитник"
                            :items="availableDefenders(selectedDefenders[(link-1)*2])"
                            item-text="desc"
                            no-data-text="У вас больше игроков на этой позиции"
                            return-object
                            clearable
                            hide-selected>

                    </v-select>
                    <v-select
                            class="selector"
                            v-model="selectedDefenders[(link-1)*2+1]"
                            label="Защитник"
                            :items="availableDefenders(selectedDefenders[(link-1)*2+1])"
                            item-text="desc"
                            no-data-text="У вас больше игроков на этой позиции"
                            return-object
                            clearable
                            hide-selected>
                    </v-select>
                    <h5>Нападающие</h5>
                    <v-select
                            class="selector"
                            v-model="selectedForwards[(link-1)*3]"
                            label="Нападающий"
                            apend-item="pos"
                            :items="availableForwards((link-1)*3)"
                            item-text="desc"
                            no-data-text="У вас больше игроков на этой позиции"
                            return-object
                            clearable
                            hide-selected>
                    </v-select>
                    <v-select
                            class="selector"
                            v-model="selectedForwards[(link-1)*3+1]"
                            label="Нападающий"
                            :items="availableForwards((link-1)*3+1)"
                            item-text="desc"
                            no-data-text="У вас больше игроков на этой позиции"
                            return-object
                            clearable
                            hide-selected>
                    </v-select>
                    <v-select
                            class="selector"
                            v-model="selectedForwards[(link-1)*3+2]"
                            label="Нападающий"
                            :items="availableForwards((link-1)*3+2)"
                            item-text="desc"
                            no-data-text="У вас больше игроков на этой позиции"
                            return-object
                            clearable
                            hide-selected>
                    </v-select>
                </v-layout>
            </v-layout>
        </v-layout>
        <v-layout row class="hidden-sm-and-down" justify-space-beetwen>
            <v-layout class="link" column v-for="link in 3" :key="link">
                <h3 class="px-0">Пятерка {{link}}</h3>
                <v-layout column>
                    <h5>Защитники</h5>
                    <v-select
                            class="selector"
                            v-model="selectedDefenders[(link-1)*2]"
                            label="Защитник"
                            :items="availableDefenders(selectedDefenders[(link-1)*2])"
                            item-text="desc"
                            no-data-text="У вас больше игроков на этой позиции"
                            return-object
                            clearable
                            hide-selected>

                    </v-select>
                    <v-select
                            class="selector"
                            v-model="selectedDefenders[(link-1)*2+1]"
                            label="Защитник"
                            :items="availableDefenders(selectedDefenders[(link-1)*2+1])"
                            item-text="desc"
                            no-data-text="У вас больше игроков на этой позиции"
                            return-object
                            clearable
                            hide-selected>
                    </v-select>
                    <h5>Нападающие</h5>
                    <v-select
                            class="selector"
                            v-model="selectedForwards[(link-1)*3]"
                            label="Нападающий"
                            apend-item="pos"
                            :items="availableForwards((link-1)*3)"
                            item-text="desc"
                            no-data-text="У вас больше игроков на этой позиции"
                            return-object
                            clearable
                            hide-selected>
                    </v-select>
                    <v-select
                            class="selector"
                            v-model="selectedForwards[(link-1)*3+1]"
                            label="Нападающий"
                            :items="availableForwards((link-1)*3+1)"
                            item-text="desc"
                            no-data-text="У вас больше игроков на этой позиции"
                            return-object
                            clearable
                            hide-selected>
                    </v-select>
                    <v-select
                            class="selector"
                            v-model="selectedForwards[(link-1)*3+2]"
                            label="Нападающий"
                            :items="availableForwards((link-1)*3+2)"
                            item-text="desc"
                            no-data-text="У вас больше игроков на этой позиции"
                            return-object
                            clearable
                            hide-selected>
                    </v-select>
                </v-layout>
            </v-layout>
        </v-layout>

        <p v-bind:class="{ 'errorMessage' : hasError, 'successMessage': !hasError }">{{message}}</p>
        <h5 v-show="loaded">Отправить состав на {{matchday}} тур</h5>
        <v-btn dark color="primary" @click="click" v-show="loaded">Отправить</v-btn>
    </div>
</template>

<script>
    import firebase from "firebase";

    export default {
        data() {
            return {
                // matchday: null,
                goalkeepers: [],
                defenders: [],
                forwards: [],
                selectedGoalkeepers: [],
                selectedDefenders: [],
                selectedForwards: [],
                message: '',
                currentTeamRoster: {},
                currentTeamPlayers: [],
                hasError: false
            };
        },
        methods: {
            availableForwards(index) {
                let forward = this.selectedForwards[index];

                let numberOfWrongFives = 0;
                let wrongFive;

                for (let i = 0; i < 3; i++) {
                    let lw = this.forwards.find(item =>
                        this.selectedForwards[i * 3] && item.name === this.selectedForwards[i * 3].name);
                    let c = this.forwards.find(item =>
                        this.selectedForwards[i * 3 + 1] && item.name === this.selectedForwards[i * 3 + 1].name);
                    let rw = this.forwards.find(item =>
                        this.selectedForwards[i * 3 + 2] && item.name === this.selectedForwards[i * 3 + 2].name);

                    if (
                        ((lw && c) && lw.pos === c.pos)
                        || ((lw && rw) && lw.pos === rw.pos)
                        || ((c && rw) && c.pos === rw.pos)
                    ) {
                        numberOfWrongFives++;
                        wrongFive = i;
                        break
                    }
                }

                if (numberOfWrongFives < 1 || wrongFive === Math.floor(index / 3)) {
                    let availableForwards = this.forwards.filter(
                        item => !this.selectedForwards.map(item => item && item.name).includes(item.name)
                    );
                    return this.selectedForwards.length
                        ? forward
                            ? availableForwards.concat(forward)
                            : availableForwards
                        : this.forwards;
                } else {

                    let five = Math.floor(index / 3);

                    let selectedPositionsInCurrentFive = [
                        this.selectedForwards[five * 3],
                        this.selectedForwards[five * 3 + 1],
                        this.selectedForwards[five * 3 + 2]
                    ]
                    // .filter(item => item.pos)
                        .filter(item => item && this.selectedForwards[index]
                            ? item.pos !== this.selectedForwards[index].pos
                            : item)
                        .map(item => item.pos);


                    let availableForwards = this.forwards.filter(
                        item => !this.selectedForwards.filter(item => item).map(item => item.name).includes(item.name)
                            && !selectedPositionsInCurrentFive.includes(item.pos)
                    );
                    let forwards = this.selectedForwards.length
                        ? forward
                            ? availableForwards.concat(forward)
                            : availableForwards
                        : this.forwards;

                    forwards.sort((a, b) => {
                        if (a.pos < b.pos) {
                            return -1;
                        } else if (a.pos > b.pos) {
                            return 1;
                        } else
                            return 0;
                    });
                    return forwards
                }
            },
            availableGoalkeepers(goalkeeper) {

                let availableGoalkeepers = this.goalkeepers.filter(
                    item => !this.selectedGoalkeepers.map(item => item && item.name).includes(item.name)
                );
                return this.selectedGoalkeepers.length
                    ? goalkeeper
                        ? availableGoalkeepers.concat(goalkeeper)
                        : availableGoalkeepers
                    : this.goalkeepers;
            },
            availableDefenders(defender) {
                let availableDefenders = this.defenders.filter(
                    item => !this.selectedDefenders.map(item => item && item.name).includes(item.name)
                );
                return this.selectedDefenders.length
                    ? defender
                        ? availableDefenders.concat(defender)
                        : availableDefenders
                    : this.defenders;
            },
            roster() {
                return new Promise((resolve, reject) => {
                    let roster = {
                        goalkeepers: [],
                        fives: []
                    };
                    for (let i = 0; i < 2; i++) {
                        if (this.selectedGoalkeepers[i]) {
                            roster.goalkeepers.push(
                                this.goalkeepers.find(item => item.name === this.selectedGoalkeepers[i].name)
                            )
                        } else {
                            reject('Состав не полностью укомплектован')
                        }
                    }
                    for (let i = 0; i < 3; i++) {
                        if (this.selectedDefenders[i * 2]
                            && this.selectedDefenders[i * 2 + 1]
                            && this.selectedForwards[i * 3]
                            && this.selectedForwards[i * 3 + 1]
                            && this.selectedForwards[i * 3 + 2]
                        ) {
                            roster.fives.push(
                                {
                                    defenders: [
                                        this.defenders.find(item => item.name === this.selectedDefenders[i * 2].name),
                                        this.defenders.find(item => item.name === this.selectedDefenders[i * 2 + 1].name)
                                    ],
                                    forwards: [
                                        this.forwards.find(item => item.name === this.selectedForwards[i * 3].name),
                                        this.forwards.find(item => item.name === this.selectedForwards[i * 3 + 1].name),
                                        this.forwards.find(item => item.name === this.selectedForwards[i * 3 + 2].name)
                                    ]
                                }
                            )
                        } else {
                            reject('Состав не полностью укомплектован')
                        }
                    }
                    return resolve(roster)
                })
            },
            click() {
                this.roster().then(roster => {
                    let user = firebase.auth().currentUser;
                    let object = {
                        team: user.uid,
                        roster: roster,
                        matchday: parseInt(this.matchday)
                    };

                    firebase
                        .firestore()
                        .collection('rosters')
                        .where("team", "==", user.uid)
                        .where("matchday", "==", object.matchday)
                        .limit(1)
                        .get()
                        .then(roster => {
                                // eslint-disable-next-line no-console
                                console.log('document reads', roster.size)
                                if (roster.size) {
                                    // eslint-disable-next-line no-unused-vars
                                    roster.docs[0].ref.set(object)
                                } else {
                                    // eslint-disable-next-line no-unused-vars
                                    firebase.firestore().collection('rosters').add(object)
                                }
                            }
                        );


                    this.hasError = false
                    this.message = 'Состав успешно отправлен'

                }).catch(error => {
                    this.message = error
                    this.hasError = true
                })
            },
            processPlayers(currentPlayers) {
                this.currentTeamPlayers = currentPlayers;
                this.goalkeepers = [];
                this.defenders = [];
                this.forwards = [];
                for (let i in currentPlayers) {
                    let player = currentPlayers[i];
                    player.desc = player.pos + ", " + player.name + ", " + player.realTeam;
                    if (player.pos === "G") {
                        this.goalkeepers.push(player);
                    } else if (player.pos === "D") {
                        this.defenders.push(player);
                    } else {
                        this.forwards.push(player);
                    }
                }
            },
            processRoster(roster) {
                this.currentTeamRoster = roster;
                this.selectedGoalkeepers = [];
                this.selectedDefenders = [];
                this.selectedForwards = [];
                if (roster) {
                    for (let goalkeeper in roster.goalkeepers) {
                        this.selectedGoalkeepers.push(roster.goalkeepers[goalkeeper])
                    }
                    for (let five in roster.fives) {
                        for (let defender in roster.fives[five].defenders) {
                            this.selectedDefenders.push(roster.fives[five].defenders[defender])
                        }
                        for (let forward in roster.fives[five].forwards) {
                            this.selectedForwards.push(roster.fives[five].forwards[forward])
                        }
                    }
                }
            }
        },
        props: ['matchday', 'currentRoster', 'players', 'loaded'],
        watch: {
            currentRoster: {
                immediate: true,
                handler(newValue, oldValue) {
                    this.processRoster(newValue)
                }
            },
            players: {
                immediate: true,
                handler(newValue, oldValue) {
                    this.processPlayers(newValue)
                }
            }
        },
        mounted() {
            this.processRoster(this.currentTeamRoster)
            this.processPlayers(this.currentTeamPlayers)
        }
    }
    ;
</script>


<style>
    .link {
        width: 30%;
        max-width: 100%;
        margin-right: 3%;
    }

    .link_sm {
        width: 100%;
        max-width: 100%;
        margin-right: 3%;
    }

    .selector .v-select__selection {
        white-space: nowrap;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 95%;
    }

    .selector .v-select__selections {
        max-width: 751%;
    }

    .hint {
        font-size: 10px;
    }

    .errorMessage {
        height: 21px;
        color: #e53935;
    }

    .successMessage {
        height: 21px;
        color: #43a047;
    }
</style>

